import React from "react";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { BookOpen } from "lucide-react";
import { getBlogCategories } from "@/data/site";
import { useI18n } from "@/context/I18nContext";

export default function KnowledgeBase() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta(L("Knowledge Base", "Knowledge Base", "Wissensdatenbank"), L("Guide e articoli tecnici sul recupero dei wallet crypto.", "Technical guides and articles on crypto wallet recovery.", "Technische Leitfäden und Artikel zur Wiederherstellung von Krypto-Wallets."));
  return (
    <div>
      <PageHero eyebrow={L("Knowledge Base", "Knowledge Base", "Wissensdatenbank")} title={L("Documentazione e guide", "Documentation and guides", "Dokumentation und Leitfäden")}
        subtitle={L("Raccolta di articoli tecnici organizzati per argomento.", "A collection of technical articles organized by topic.", "Eine nach Themen geordnete Sammlung technischer Artikel.")} />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {getBlogCategories(lang).map((c) => (
            <div key={c} className="rounded-xl border border-white/10 bg-navy-paper p-6">
              <BookOpen className="h-5 w-5 text-cyanx" />
              <h3 className="mt-3 font-heading text-lg font-medium text-white">{c}</h3>
              <p className="mt-2 text-sm text-slate-500">{L("Articoli in preparazione.", "Articles in preparation.", "Artikel in Vorbereitung.")}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
